import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContentElement, GridCell, RowCell, TestimonialLayoutEnum, TestimonialOptions,SectionData, Section, ContentElementEnum } from '../../models/sections-model';
import { RendererDataInterFace } from '../dynamic-renderer-model';
import { Observable } from 'rxjs';

@Component({
  selector: 'kw-testimonial-renderer',
  templateUrl: './testimonial-renderer.component.html',
  styleUrls: ['./testimonial-renderer.component.scss']
})
export class TestimonialRendererComponent implements RendererDataInterFace, OnInit {
  @Input() data:Section;
  @Input() edit:boolean;
  testimonialOptions:TestimonialOptions;
  rowCells:RowCell[];
  numberOfCells:number;
  layoutClass:any;
  title:ContentElement;
  cellId:string;
  preview:boolean;
  selectedCell:GridCell | RowCell;
  wrapperClass:string;
  imgSrc:string;
  
  @Output() editUpdate = new EventEmitter<any>();
  @Output() createUpdate = new EventEmitter<RowCell>();
  /* contentElements:ContentElement[] = [
    {
      elId:"01",
      name:"Party Name",
      text:"Lorem ipsum dolor",
    },
    {
      elId:"02",
      name:"Role",
      text:"Delectus Minus",
    },
    {
      elId:"03",
      name:"Organisation",
      text:"Doloremque ratione"
    },
    {
      elId:"04",
      name:"Text",
      text:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Doloremque ratione delectus minus quaerat, omnis totam ipsum in repellat quos, aliquid fuga voluptas veritatis odit. Cumque, facere? Dicta quidem autem sint!"
    }
  ] */
  
  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    console.log(this.data);
    let sectionData:SectionData = this.data["sectionData"];
    this.wrapperClass = sectionData.wrapperClass?sectionData.wrapperClass:"solid";
    this.testimonialOptions = sectionData.testimonialOptions;
    this.title = this.data["title"];
    this.rowCells = this.testimonialOptions.rowCells;
    console.log(this.rowCells[0].imgSrc);
    //set the default container classes on all content elements
    this.rowCells.forEach((rowCell) => {
      console.log("setDefaultContainerClasses")
      this.setDefaultContainerClasses(rowCell);
      //console.log(index+":"+rowCell.imgSrc);
    })
    this.imgSrc = this.rowCells[0].imgSrc;
    this.numberOfCells = this.rowCells.length;
    this.layoutClass = sectionData.layoutClass;
    //this.layoutClass = this.testimonialOptions.layoutClass?this.testimonialOptions.layoutClass:TestimonialLayoutEnum.ONE_HORISONTAL;
    console.log(this.layoutClass);
    this.preview = sectionData.isPreview?sectionData.isPreview:false;
    this.selectedCell = sectionData.selectedCell?sectionData.selectedCell:this.rowCells[0];
    if(sectionData.selectedCell){
      this.cellId = sectionData.selectedCell.cellId;
    }
  }

  setDefaultContainerClasses(rowCell:RowCell):void{
    rowCell.contentElements.forEach(cntEl => {
      if(!cntEl.containerClasses){
        cntEl.containerClasses = [];
      }
      switch (this.getEnumValue(cntEl)) {
        case "header":
          cntEl["containerClasses"].push("header-container");
          break;
        case "sub-header":
          cntEl["containerClasses"].push("sub-header-container")
          break;
        case "caption":
          cntEl["containerClasses"].push("caption-container")
          break;
        case "text":
          cntEl["containerClasses"].push("text-container")
          break;
        default:
          break;
      }
      console.log(cntEl) 
    })
  }

  createContent(cell:GridCell|RowCell){
    console.log(cell)
    this.createUpdate.emit(cell);
  }
  updateSection(section:Section){
    console.log(section);
    this.data = section;
    this.rowCells = section.sectionData.testimonialOptions.rowCells;
    //console.log(this.cells);
    this.cdr.detectChanges();
  }
  
  getEnumValue(contentElement:ContentElement){
    let enumValue:string;
    let titleEnum = contentElement.contentElementEnum
    if(titleEnum != undefined){
      if((titleEnum).includes(".")){
        let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
        enumValue = ContentElementEnum[enumKey];
      }else if(ContentElementEnum[titleEnum] != undefined){
        enumValue = ContentElementEnum[titleEnum]
      }else{
        enumValue = titleEnum;
      }
    }
    //if(enumValue) enumValue = <string>enumValue.toUpperCase();
    
    return enumValue;
    /* console.log(titleEnum)
    let title;
    if((titleEnum).includes(".")){
      let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
      title = ContentElementEnum[enumKey];
    }else if(ContentElementEnum[titleEnum] != undefined){
      title = ContentElementEnum[titleEnum]
    }else{
      title = titleEnum;
    }
    console.log(title)
    return title */
  }

}
